// extracted by css-extract-rspack-plugin
export default {"preview":"h3SvPe2cJxYdjgXF"};